/**
 * Hàng cùng loại (đơn vị quy đổi) có mã `<maGoc>-n`; chứng từ đã có ĐVT nên hiển thị mã gốc.
 * Nhận object hàng hóa từ BE (`hangHoaGoc.maHangHoa`) hoặc IProduct (`hangHoaGocMa`).
 */
export const maHangHienThi = (hangHoa: unknown, fallback?: unknown): string => {
  const hh = hangHoa && typeof hangHoa === 'object' ? (hangHoa as Record<string, unknown>) : null
  const goc = hh?.hangHoaGoc && typeof hh.hangHoaGoc === 'object'
    ? (hh.hangHoaGoc as Record<string, unknown>).maHangHoa
    : null
  const v = goc || hh?.hangHoaGocMa || hh?.maHangHoa || fallback
  return v != null ? String(v) : ''
}

/** Chỉ mã gốc (`hangHoa.hangHoaGoc.maHangHoa`) — null nếu không phải hàng cùng loại. */
export const maGocTuHangHoa = (hangHoa: unknown): string | null => {
  const hh = hangHoa && typeof hangHoa === 'object' ? (hangHoa as Record<string, unknown>) : null
  const goc = hh?.hangHoaGoc && typeof hh.hangHoaGoc === 'object'
    ? (hh.hangHoaGoc as Record<string, unknown>).maHangHoa
    : null
  return goc != null && String(goc).trim() ? String(goc) : null
}

/**
 * Mã hiển thị của dòng trong form (state dòng giữ `product` = IProduct + mã thật `maDong` để gửi payload).
 * Product là catalog hàng gốc (đổi ĐVT) hoặc chính hàng cùng loại (`hangHoaGocMa`).
 */
export const maHangHienThiDongForm = (product: unknown, maDong: unknown): string => {
  const p = product && typeof product === 'object' ? (product as Record<string, unknown>) : null
  const v = maGocTuHangHoa(p) || p?.hangHoaGocMa || p?.code || maDong
  return v != null ? String(v) : ''
}

/**
 * Mã in của dòng: record BE (`hangHoa`), record dựng từ form (`product` IProduct)
 * hoặc dòng đã map sẵn `hangHoaGocMa`; `ma` = mã snapshot của dòng.
 */
export const maHangHienThiDongIn = (line: Record<string, unknown>, ma?: unknown): string => {
  const raw = line.hangHoa ?? line.product
  const hh = raw && typeof raw === 'object' ? (raw as Record<string, unknown>) : null
  const v =
    maGocTuHangHoa(hh) ||
    line.hangHoaGocMa ||
    hh?.hangHoaGocMa ||
    (ma ?? line.maHangHoa) ||
    hh?.maHangHoa ||
    hh?.code
  return v != null ? String(v) : ''
}

/** Mã hiển thị của dòng chi tiết chứng từ (`line.hangHoa` + snapshot `line.maHangHoa`). */
export const maHangHienThiCuaDong = (line: Record<string, unknown> | null | undefined): string => {
  if (!line) return ''
  const hh = line.hangHoa && typeof line.hangHoa === 'object' ? (line.hangHoa as Record<string, unknown>) : null
  const goc = hh?.hangHoaGoc && typeof hh.hangHoaGoc === 'object'
    ? (hh.hangHoaGoc as Record<string, unknown>).maHangHoa
    : null
  const v = goc || line.maHangHoa || hh?.maHangHoa
  return v != null ? String(v) : ''
}
